<template>
  <dialog :open="open" class="confirmation-content">
    <form method="dialog" class="eds-form">
      <div class="form-header">
        <div v-if="!isUsed">
          <b>Remove {{ removeType.toLowerCase() }}?</b>
        </div>
        <div v-else-if="isEdit">
          <b>Replace {{ removeType.toLowerCase() }}?</b>
        </div>
        <div v-else>
          <b>{{ removeType }} is being used by products!</b>
        </div>
      </div>
      <div class="form-body">
        <div v-if="!isUsed">
          Are you sure you want to remove {{ removeFile }}?
        </div>
        <div v-else-if="isEdit">
          <div>{{ assetCreateModel.asset.path }} already exist.</div>
          <div>
            Are you sure you want to replace it, the existing
            {{ removeType.toLowerCase() }} will be replaced.
          </div>
        </div>
        <div v-else>
          <div>{{ removeFile }} is being used by the following products.</div>
          <div>
            Remove the reference from these products before you can remove the
            {{ removeType.toLowerCase() }}.
          </div>
          <ul class="product-list">
            <li v-for="(item, index) in products" :key="index">{{ item }}</li>
          </ul>
        </div>
      </div>
      <div class="form-footer">
        <button type="button" class="btn" @click="$emit('close')">
          {{ isUsed ? 'Close' : 'Cancel' }}
        </button>
        <button
          v-if="!isUsed"
          type="submit"
          class="btn warning"
          @click="deleteAsset">
          Remove {{ removeType }}
        </button>
        <button v-if="isEdit" type="submit" class="btn primary" @click="updateAsset">
          Replace {{ removeType }}
        </button>
      </div>
    </form>
  </dialog>
</template>

<script>
import AssetsApiService from '@/services/assetsServices/assetsApiService';

export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },

    removeType: {
      type: String,
      default: '',
    },

    removeFile: {
      type: String,
      default: '',
    },

    isUsed: {
      type: Boolean,
      default: false,
    },

    isEdit: {
      type: Boolean,
      default: false,
    },

    products: {
      type: Array,
      default: [],
    },

    removalFileId: {
      type: String,
      required: true,
    },

    assetCreateModel: {
      type: Object,
      default: {}
    }
  },

  methods: {
    async deleteAsset() {
      await AssetsApiService.deleteAsset(this.removalFileId);

      this.$emit('close');
    },

    async updateAsset() {
      await AssetsApiService.updateAsset(this.assetCreateModel);

      this.$emit('close');
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/global.less';
@import '~@eds/vanilla/variables/dark.less';

.confirmation-content {
  position: absolute;
  top: 30%;
  left: 35%;
  padding: 1rem;
  background-color: @gray-14;
  width: 30vw;
}

.form-header,
.form-body {
  color: @white;
}

.product-list {
  padding: 1rem;
  margin-top: 0.5rem;
  max-height: 10rem;
  overflow: scroll;
}
</style>